// AudioTable.js

import React, {useState, useEffect} from 'react';
import { storage } from './firebase';
import Button from '@mui/material/Button';
import { v4 as uuidv4 } from 'uuid';
import {useAudio} from './AudioProvider_file';


const SampleAudioTable = () => {
  const {audioUrls,loading} = useAudio();

  const handleSampleMusicPlayWithParams = (className, sampleName) => {
    const audioElement = document.getElementById(`audio-player-${className}-${sampleName}`);
    if (audioElement) {
      audioElement.play();
    }
  };

  if (loading) {
    return <div>Loading...</div>
  }

  return (
    <div id='top-sample-audio-table'>
      <div className='sample-class-container class1-container'>
        <div className='sample-class-title'>Class 1</div>
        <div className="top-sample-button-container">
        {Object.entries(audioUrls).map(([className, samples]) => (
            Object.entries(samples).map(([sampleName, url]) => {
              if (className === 'class1')
                return (
                  <div key={`${className}-${sampleName}`}
                    id={`${className}-${sampleName}`}
                    className={`${className} top-sample-button`} onClick={handleSampleMusicPlay}>
                    <img src="/images/speaker_icon.png"
                      alt={`Click to hear Sample for ${className}`}
                      onClick={() => handleSampleMusicPlayWithParams(className, sampleName)}
                      style={{ cursor: 'pointer' }} />
                    <audio src={url}
                      id={`audio-player-${className}-${sampleName}`}
                      className='audio-player'></audio>
                  </div>
                )
            })
          ))}
        </div>
        <div className='sample-class-description'>Unintelligible Audio</div>
      </div>
      {/* Repeat the same structure for class2-container and class3-container */}
      <div className='sample-class-container class2-container'>
        <div className='sample-class-title'>Class 2</div>
        <div className="top-sample-button-container">
        {Object.entries(audioUrls).map(([className, samples]) => (
            Object.entries(samples).map(([sampleName, url]) => {
              if (className === 'class2')
                return (
                  <div key={`${className}-${sampleName}`}
                    id={`${className}-${sampleName}`}
                    className={`${className} top-sample-button`} onClick={handleSampleMusicPlay}>
                    <img src="/images/speaker_icon.png"
                      onClick={() => handleSampleMusicPlayWithParams(className, sampleName)}
                      style={{ cursor: 'pointer' }} />
                    <audio src={url}
                      id={`audio-player-${className}-${sampleName}`}
                      className='audio-player'></audio>
                  </div>
                )
            })
          ))}
        </div>
        <div className='sample-class-description'>Slightly Intelligible Audio</div>
      </div>
      <div className='sample-class-container class3-container'>
        <div className='sample-class-title'>Class 3</div>
        <div className="top-sample-button-container">
        {Object.entries(audioUrls).map(([className, samples]) => (
            Object.entries(samples).map(([sampleName, url]) => {
              if (className === 'class3')
                return (
                  <div key={`${className}-${sampleName}`}
                    id={`${className}-${sampleName}`}
                    className={`${className} top-sample-button`} onClick={handleSampleMusicPlay}>
                    <img src="/images/speaker_icon.png"
                      onClick={() => handleSampleMusicPlayWithParams(className, sampleName)}
                      style={{ cursor: 'pointer' }} />
                    <audio src={url}
                      id={`audio-player-${className}-${sampleName}`}
                      className='audio-player'></audio>
                  </div>
                )
            })
          ))}
        </div>
        <div className='sample-class-description'>Intelligible Audio</div>
      </div>
    </div>
  );
};




const handleSampleMusicPlayWithUrl = (url) => {
  const audio = new Audio(url);
    audio.play();
}
const handleSampleMusicPlay = (e) => {
  // console.log("Inside handleSampleMusicPlay");
  // Find the closest div with class "sample-audio-cell"
  const sampleAudioCell = e.currentTarget.closest('.audio-player');
  if (sampleAudioCell) {
    // Find the audio element within that cell
    const audioElement = sampleAudioCell.querySelector('.audio-player');
    if (audioElement) {
      // Play the audio
      audioElement.play();
    }
  }
};


const SampleAudioQuiz = (props) => {
    const [selectedOptions, setSelectedOptions] = useState({});
    const [score, setScore] = useState(0);
    const [audioSampleFiles, setAudioSampleFiles] = useState({});
    const {audioUrls, loading} = useAudio();
    const [disableNextButtonState, setDisableNextButtonState] = useState(true)
    
    // console.log("tutorial index list = ", props.tutorial_index_list);
    // const key = uuidv4();
    const flatAudioSampleFiles = Object.entries(audioUrls).flatMap(([className, samples], high_index) =>
      Object.entries(samples).map(([sampleName, url], index) => ({ 
                                        'key': uuidv4(), //`${sampleName}-${high_index*3 + index}`,
                                        className, 
                                        index:`${high_index*3 + index}` , 
                                        url }))
    );
    
    // var audioSampleFiles = Object.entries(props.tutorial_index_list).map(i => flatAudioSampleFiles[i]);

    // console.log("audioUrls = ", audioUrls);
    // setSampleAudioFiles(files.sort(() => Math.random() - 0.5)); // Randomize the order
    useEffect(() => {
      // console.log("audioSampleFiles = ", audioSampleFiles);
      
      if (!loading) {
      setAudioSampleFiles(Object.entries(props.tutorial_index_list).map(i=>flatAudioSampleFiles[i[1]]));
      }
    }, [loading]);
    

    const handleOptionChange = (index, selectedClass) => {
      setSelectedOptions(prev => ({ ...prev, [index]: selectedClass }));  
    };

    // useEffect(() => {
    //   // console.log("selectedOptions = ", selectedOptions);
    // }, [selectedOptions]);

    function showCorrectBorder(id){
      const element = document.getElementById(id);
      if (element) {
        element.style.border = "3px solid limegreen";
      }
    } 

    function showIncorrectBorder(id){
      const element = document.getElementById(id);
      if (element) {
        element.style.border = "3px solid red";
      }
    } 

    const handleTrialMCQFormSubmit = (e) => {
      e.preventDefault();
      let newScore = 0;
      
      audioSampleFiles.forEach((file, index) => {
        if (selectedOptions[index] === file.className) {
          //`label-${file.key}-class1`
          showCorrectBorder('label-' + file.key+'-' + file.className);
          newScore++;
        } else {
          showIncorrectBorder('label-' + file.key + '-' + selectedOptions[index]);
          showCorrectBorder('label-' + file.key + '-' + file.className);
        }

      });
      setScore(newScore);
      showScore()
      if (newScore >= 8){
        // user passed 
        // show Next button and save the result
        props.saveTutorialComplete();
        setDisableNextButtonState(false);
        document.getElementById('trial_quiz_next_btn').style.display='block';
      } else {
        document.getElementById('score_below_threshold').style.display='block';
      }

    };

    const showScore = () => {
      const score_div = document.getElementById('trial_quiz_score_text');
      score_div.style.display = 'block';
    }

    if (loading) {
      console.log("Loading was true");
      return <div  id="loading_text">Loading...</div>; // Display loading indicator while fetching data
    } 
    else
    {
      
      // function array_copy(element) {
      //   console.log("element = ", element);
      //   console.log("flatAudioSmaple[element] -", flatAudioSampleFiles[element[1]]);
      //   return flatAudioSampleFiles[element[1]];
      // }
      // const audioSampleFiles = Object.entries(props.tutorial_index_list).map(array_copy);
      // console.log("loading = " + loading + " audioSampleFiles = ", audioSampleFiles);
      // console.log("flatAudioSmaple -", flatAudioSampleFiles);
      // console.log("flatAudioSmaple[2] -", flatAudioSampleFiles[2]);
    if (audioSampleFiles.map == null)
      return <div>Loading...</div>
    else
      return (

    <form id="sample-quiz-form" 
      onSubmit={handleTrialMCQFormSubmit}>
      {audioSampleFiles.map((file, i) => (
        <div id={file.key} key={file.key} className='question'>
          <div className="question-container">
          <audio src={file.url}
                      key={`audio-player-${file.key}`}
                      id={`audio-player-${file.key}`}
                      className='audio-player'></audio>
          <img  src="/images/speaker_icon.png" 
                
                id={`spk-img-${file.key}`}
                alt="Play"  className='speaker-img'
                onClick={() => handleSampleMusicPlayWithUrl(file.url)} 
                style={{ cursor: 'pointer' }} />
          <div className='option-group' 
              key={`option-group-${file.key}`}
              id={`option-group-${file.key}`}>
            <label className='option'
                      id={`label-${file.key}-class1`}
                      >
              <input  type="radio" 
                      id={`input-${file.key}-class1`}
                      checked={selectedOptions[i] === 'class1'}
                      name={file.key} 
                      value="class1" 
                      required
                      onChange={() => handleOptionChange(i, 'class1')} 
                      />
              <p>
              <strong>Class 1:</strong> There is a lot of noise and I cannot hear most of the words. 
              And hence cannot understand what is being said
              </p>
            </label>
            <label className='option'
                    id={`label-${file.key}-class2`}
                    >
              <input  type="radio" 
                      id={`input-${file.key}-class2`}
                      checked={selectedOptions[i] === 'class2'}
                      name={file.key} 
                      value="class2" 
                      required
                      onChange={() => handleOptionChange( i, 'class2')} 
                      />
                <p>
                <strong>Class 2:</strong> Inspite of noise, I can hear speech. 
                Few words may be difficult to hear, but other words are understandable.
              </p>
            </label>
            <label className='option'
                    id={`label-${file.key}-class3`}
                    >
              <input type="radio" 
                    id={`input-${file.key}-class3`}
                    checked={selectedOptions[i] === 'class3'}
                    name={file.key}  
                    required
                    value="class3" 
                    onChange={() => handleOptionChange( i, 'class3')} 
                    />
              <p>
              <strong>Class 3:</strong> There is almost no noise, the speech is readily understandable
              </p>
            </label>
          </div>
          </div>
          <hr className='horizontal-line-separator'/>
        </div>

      ))}
      <div className="button_and_score">
      <Button variant="contained" onClick={handleTrialMCQFormSubmit}>Submit </Button>
      
      <div id='trial_quiz_score'><p id='trial_quiz_score_text'>Your score is: {score}</p>
      <br/>
      <p id="score_below_threshold">The score is below threshold. Please review your selections and you may try again</p></div>
      
        <Button id="trial_quiz_next_btn" 
                disabled={disableNextButtonState}
                variant="contained" 
                onClick={props.setTutorialCompleteState}>Next</Button>
      
      </div>

    </form>
  );
  }
};


// const handleChange = (event, className) => {
//   const name = event.target.name;
//   const value = event.target.value;
//   // event.target.checked = true;
  
//   console.log("Event.target =",event.target);
 
// }

export  {SampleAudioQuiz, SampleAudioTable};
